<script>
import {useI18n} from "vue-i18n";
import {usePaymentProcessorStore} from "@/javascript/stores/paymentProcessors";
import PaymentProcessorCard from "@/javascript/views/clientDashboard/payment/PaymentProcessorCard.vue";
import {ApplicationHelper} from "../../../helpers/ApplicationHelper";
import Tooltip from "../../components/tooltip.vue";

export default {
  components: {Tooltip, PaymentProcessorCard},
  setup() {

    // I18n
    const {t} = useI18n();
    // Router
    const processorStore = usePaymentProcessorStore();

    return {
      t,
      processorStore
    };
  },
  data() {
    return {
      validProcessorTypes: [
        "HELCIM",
        "STRIPE",
        //"OFFLINE"
      ]
    };
  },

  computed: {
    ApplicationHelper() {
      return ApplicationHelper;
    },
    activeParentProcessor() {
      return this.processorStore.activeParentProcessor || null;
    }
  },
  watch: {
    'processorStore.organizationId'() {
      this.processorStore.getOrgPaymentProcessors();
    }
  },
  mounted() {
    this.processorStore.getOrgPaymentProcessors();
  },
  methods: {
    getProcessorByType(type) {
      return this.processorStore.getProcessorByType(type) || null;
    },

  },
};
</script>

<template>
  <div class="payment-processors-container p-4">
    <div class="font-bold mb-8">
      Your Payment Processors
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2">
      <payment-processor-card
        v-for="type in validProcessorTypes"
        :key="getProcessorByType(type)?.id"
        :payment-processor="getProcessorByType(type)"
        :processor-type="type"
        :show-intervals="type !== 'OFFLINE' "
        :show-success-url="type !== 'OFFLINE' "
      />
    </div>

    <div
      v-if="activeParentProcessor"
    >
      <div class="inline-flex flex-row my-4">
        <div class="font-bold">
          Other Payment Processors
        </div>
        <tooltip
          class="ml-2"
          variant="question"
          size="16px"
          color="#3a4473"
        >
          <template #message-slot>
            <div>Other Payment Processors.</div>
            <div class="mt-2">
              If you do not have a payment processor configured to accept gifts (Helcim, Stripe),
              the payment processor of your parent organization will be used to processes payments.
            </div>
          </template>
        </tooltip>
      </div>
      <div class="w-96">
        <payment-processor-card
          :payment-processor="activeParentProcessor"
          :processor-type="ApplicationHelper.formatPaymentProcessorType(activeParentProcessor?.type)"
          :show-intervals="true"
          :show-organization-name="true"
        />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">

</style>
